export default "__VITE_ASSET__92fffa76__"